
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import loges from '../../components/course/loges.vue'

@Component({
  name: 'DashboardBusinessDetails',
  components: {}
})
export default class extends Vue {
  @Prop() businessDetails: any
  @Prop() is_show_business_info: boolean

  p_hight: any = window.innerHeight - 100 + 'px'

  @Watch('is_show_business_info')
  getId(newVal, oldVal) {
    if(newVal) {
      this.getHeight()
    }
  }
  close() {
     this.$emit('close-business', false)
  }
  getHeight() {
    window.onresize = () => {
      this.p_hight = window.innerHeight - 100 + 'px'
    }
  }

  mounted() {}
}
